import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      gray: { gray20 },
      primary: { primaryBlue2 },
      // whiteOpacity92,
    },
  } = styleConfig;

  return {
    button: {
      color: 'primary',
      width: '140',
    },
    leftIcon: {
      color: gray20,
      marginRight: '10px',
      width: '26px',
      height: '26px',
    },
    buttonWrapper: {
      justifyContent: 'space-between',
      width: '100%',
      display: 'flex',
      margin: '20px 0 0 0',
    },
    // waterMark: {
    //   display: 'none',
    //   visibility: 'visible',
    // },
    paperStyle: { height: '100vh', position: 'relative' },
    backBtnPosition: {
      position: 'absolute',
      bottom: 100,
      right: 100,
      backgroundColor: primaryBlue2,
      '&:hover': {
        backgroundColor: primaryBlue2,
      },
    },
    backIconStyle: { width: 35, height: 35 },
  };
};

export default styles;
